import { defineMessages } from 'react-intl';

export default defineMessages({
    userSaveFailed: {
        id: 'portal.views.administration-table.Saving User Failed',
        defaultMessage: 'Saving User Failed',
    },
    userSaveFailedMessage: {
        id: 'portal.views.administration-table.The user is a Primary Contact',
        defaultMessage: 'The user is a Primary Contact. Please assign a different Primary Contact before deactivating this user.',
    },
    ok:{
        id: 'portal.views.administration-table.Ok',
        defaultMessage: 'Ok'
    },
    orgAdmin:{
        id: 'agency.admin.views.messages.orgAdmins',
        defaultMessage: 'Organization Administrators'
    },
    users:{
        id: "agency.admin.views.messages.Users",
        defaultMessage: "Users"
    },
    deactivateUser: {
        id: "portal.views.administration-table.Deactivate User",
        defaultMessage: 'Deactivate User'
    },
    deactivate: {
        id: "portal.views.administration-table.Deactivate",
        defaultMessage: 'Deactivate'
    },
    activateUser: {
        id: "portal.views.administration-table.Activate User",
        defaultMessage: "Activate User"
    },
    activate: {
        id: "portal.views.administration-table.Activate",
        defaultMessage: "Activate"
    }
});
